import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-bootstrap-icon',
  standalone: true,
  template: `<i [class]="classes()" aria-hidden="true"></i>`,
})
export class BootstrapIcon {
  readonly name = input.required<string>();
  readonly sizeClass = input('text-3xl');
  readonly colorClass = input('text-blue-600');

  protected readonly classes = computed(
    () => `bi bi-${this.name()} ${this.sizeClass()} ${this.colorClass()}`.trim(),
  );
}
